<!-- Start Subscribe Area -->
<section class="subscribe-area bg-F4F7FC">
    <div class="container-fluid p-0">
        <div class="subscribe-inner-area jarallax" data-jarallax='{"speed": 0.3}' style="background-image: none;">
            <div class="subscribe-content">
                <span class="sub-title">Never miss an Update!</span>
                <h2>Get latest updates from us</h2>

                <form class="newsletter-form" [formGroup]="subscriptionForm" (ngSubmit)="subscribe()">
                    <input type="email" class="input-newsletter" placeholder="Enter your email" name="EMAIL" formControlName="email" required>
                    <button type="submit">Subscribe</button>
                </form>
            </div>
        </div>
    </div>
</section>
<!-- End Subscribe Area -->